import React from "react";
import Update from "modules/currencies/components/Update";

const CurrenciesUpdatePage = () => {
  return <Update />;
};

export default CurrenciesUpdatePage;
